import {Bless, BlesserClass, BlessType} from "@/store/battle/types";
import CreaturePanel from "@/scenes.ui/creature-panel";
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import {Scene} from "phaser";
import {CreatureUtils} from "@/utils/creature-utils";
import {PhrasePanel} from "@/scenes.ui/phrase-panel";

export class BlessUtils {

    public static animateBlessMove(scene: Scene, bless: Bless, blesserContainer: CreaturePanel, targetContainer: CreaturePanel,
                                   contactCallback: () => unknown) {
        let bc = bless.blesserClass;

        if (bc === BlesserClass.NUN || bc === BlesserClass.MARTYR) {
            let blessSprite = SpriteUtils.addSprite(scene, blesserContainer.x, targetContainer.y - 60, Keys.ATLAS_EFFECTS, this.blessIcon(bless));

            let self = this;

            let dur = 250 + Math.random() * 150 + bless.queueNumber * 200;

            scene.tweens.chain({
                targets: blessSprite,
                tweens: [
                    {
                        duration: dur,
                        props: {
                            x: {value: (targetContainer.x + blesserContainer.x) / 2, ease: 'Linear'},
                            y: {value: targetContainer.y - 105, ease: 'Cubic.Out'},
                        }
                    },
                    {
                        duration: dur,
                        props: {
                            x: {value: targetContainer.x, ease: 'Linear'},
                            y: {value: targetContainer.y - 60, ease: 'Cubic.In'},
                        },
                        onComplete() {
                            blessSprite.destroy();
                            contactCallback();

                            BlessUtils.doAnimateBless(scene, targetContainer, bless);
                        }
                    }
                ]
            });
        } else if (bc === BlesserClass.HUMAN || bless.blesserClass === BlesserClass.VAMPIRE_ENEMY || bless.blesserClass === BlesserClass.PHOENIX_ENEMY) {
            contactCallback();
            BlessUtils.doAnimateBless(scene, targetContainer, bless);
        } else if (bc === BlesserClass.PHOENIX_OWN || bc === BlesserClass.VAMPIRE_OWN || bc === BlesserClass.BERSERK) {
            contactCallback();
            scene.time.delayedCall(100, () => {
                BlessUtils.doAnimateBless(scene, targetContainer, bless);
            });
        }
    }

    private static doAnimateBless(scene: Scene, targetContainer: CreaturePanel, bless: Bless) {
        switch (bless.blessType) {
            case BlessType.ADD_RESURRECTION:
                BlessUtils.animateFlyUp(scene, targetContainer, Keys.ATLAS_EFFECTS, 'phoenix');
                break;
            case BlessType.PARAMS:
                break;
            case BlessType.RESURRECT:
                break;
            case BlessType.ADD_POISON:
                BlessUtils.animateFlyUp(scene, targetContainer, Keys.ATLAS_EFFECTS, 'poison');
                break;
            case BlessType.UP_FORCE:
                BlessUtils.animateForceFlyUp(scene, targetContainer, bless);
                break;
            case BlessType.DOWN_FORCE:
                BlessUtils.animateForceFlyUp(scene, targetContainer, bless);
                break;
            case BlessType.LUCK:
                BlessUtils.animateFlyUp(scene, targetContainer, Keys.ATLAS_EFFECTS, 'clover');
                break;
            case BlessType.URGENT_MOVE:
                BlessUtils.animateFlyUp(scene, targetContainer, Keys.ATLAS_EFFECTS, 'wind');
                break;
        }
    }

    private static animateFlyUp(scene: Scene, targetContainer: CreaturePanel, atlas: string, key: string) {
        let pict = SpriteUtils.addSprite(scene, targetContainer.x, targetContainer.y - 70, atlas, key);
        scene.tweens.add({
            targets: pict,
            alpha: 0,
            y: targetContainer.y - 110,
            duration: 1500
        });
    }

    private static animateForceFlyUp(scene: Scene, targetContainer: CreaturePanel, bless: Bless) {
        let pict = SpriteUtils.addSprite(scene, targetContainer.x, targetContainer.y - 80,
            CreatureUtils.getForceAtlasSemiLarge(bless.warriorClass),
            CreatureUtils.getForceIcon(bless.warriorClass, true));

        let plusOne = SpriteUtils.addSprite(scene, targetContainer.x + 20, targetContainer.y - 70, Keys.ATLAS_EFFECTS, (bless.blesserClass === BlesserClass.HUMAN || bless.blesserClass === BlesserClass.VAMPIRE_ENEMY || bless.blesserClass === BlesserClass.PHOENIX_ENEMY) ? 'minus_one' : 'arrow_plus_one');

        scene.tweens.add({
            targets: [pict, plusOne],
            alpha: 0,
            y: targetContainer.y - 110,
            duration: 1500
        });
    }

    private static blessIcon(bless: Bless): string {
        switch (bless.blesserClass) {
            case BlesserClass.NUN:
                return 'angel';
            case BlesserClass.MARTYR:
                return 'hand';
        }
        return 'angel';
    }
}